<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-md-12">
              <div class="row">
                <div
                  class="col-lg-3 col-xl-3 col-sm-6 mt-sm-0 mt-4"
                  v-for="{ name, path, icon, className, show } in modules"
                  :key="name"
                >
                  <div
                    class="card h-100 shadow-lg"
                    :class="className"
                    v-if="show"
                  >
                    <div
                      class="card-body d-flex flex-column justify-content-center text-center"
                    >
                      <router-link :to="{ name: path }">
                        <i
                          class="text-white mb-3"
                          style="font-size: 35px"
                          :class="icon"
                          aria-hidden="true"
                        ></i>
                        <h5 class="text-white text-lg">{{ name }}</h5>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const modules = [
  {
    name: "Nueva cotización",
    path: "cotizacion-unidades-nueva",
    className: "bg-gradient-warning text-dark",
    icon: "ri-add-line",
    show: true,
  },
  {
    name: "Historial cotizaciones",
    path: "cotizacion-unidades-historial",
    className: "bg-gradient-primary",
    icon: "ri-book-line",
    show: true,
  },
  {
    name: "Configuraciones",
    path: "cotizacion-unidades-parametros",
    className: "bg-gradient-primary",
    icon: "ri-settings-line",
    show: localStorage.getItem("_id") == 9 ? true : false,
  },
];
</script>

<style></style>
